import React, { useEffect, useState,useRef  } from "react";
import { Link,useNavigate  } from "react-router-dom"; 
import Header from "./Front/Header";
import Footer from "./Front/Footer";
import API_BASE_URL from "../Config";
import { v4 as uuidv4 } from "uuid";

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation, Autoplay } from 'swiper/modules';
import { toast } from "react-toastify";

import "../styles/global.css";
 

const CategoryList = () => { 
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]); 
  const [categoriesData, setCategoriesData] = useState([]); 
   

   const fetchCategoryData = () => {
      let isCalled = false;

      if (!isCalled) {
        fetch(`${API_BASE_URL}api/categories_front`)
          .then(res => res.json())
          .then(data => {
            const list = Array.isArray(data) ? data : data.data;
            setCategories(list || []);
          })
          .catch(err => console.log(err));
      }

      return () => {
        isCalled = true;
      };
  };
 
   useEffect(() => {
 fetchCategoryData();
}, []);

 

let deviceId = localStorage.getItem("device_id");
if (!deviceId) {
  deviceId = uuidv4();  // generates unique universal ID
  localStorage.setItem("device_id", deviceId);
}
 
  return (
    <>
       <Header/>
  <section className="health-concern section-padding">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h2>All Category</h2>
        </div>
        <div className="grid-6">
           {categories.map((cat, index) => (
  <div
    key={cat.id || cat.slug || index}
     className={`bg-${Math.floor(Math.random() * 6) + 1} common-bg`}
  >
    <Link to={`/category/${cat.slug}`}>
      <h4>
        {cat.name.replace(/\b\w/g, (c) => c.toUpperCase())}
      </h4>

      <img
        src={
          cat.image
            ? `${API_BASE_URL}public/category/${cat.image}`
            : `${API_BASE_URL}public/noimage.jpg`
        }
        alt={cat.name}
      />
    </Link>
  </div>
))}

           
        </div>
      </div>
    </div>
  </section> 
  
       <Footer/>
    </>
  );
};

export default CategoryList;
